import { Card } from "@amzn/stencil-react-components/card";
import { Chip, ChipBackgroundColor } from "@amzn/stencil-react-components/chip";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { Link } from "@amzn/uxm-stencil-react-components/lib/src/stencil/link";
import { createItemTaxonomy } from "common/helpers/taxonomy-helper";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC, useState } from "react";
import { useHistory } from "react-router-dom";

const DESCRIPTION_MAX_WORDS = 20;

export interface RelatedUseCase {
  title: string;
  tool: string;
  used: number;
  shortDescription?: string;
  taxonomyId: string;
}

export const RelatedUseCaseCard: FC<{ useCase: RelatedUseCase }> = ({ useCase }) => {
  const [expanded, setExpanded] = useState(false);
  const history = useHistory();
  const words = useCase.shortDescription?.split(/\s+/).filter(Boolean) ?? [];
  const needsTruncation = words.length > DESCRIPTION_MAX_WORDS;
  const displayText =
    !needsTruncation || expanded ? useCase.shortDescription : `${words.slice(0, DESCRIPTION_MAX_WORDS).join(" ")}... `;

  const detailPath = `/aiforme/usecases/detail/${
    createItemTaxonomy(useCase.taxonomyId)?.toPlainIdWithoutType() ?? useCase.taxonomyId
  }`;

  return (
    <Card padding="dimensions.spacing.300" flex={1} height="100%">
      <Col gridGap="dimensions.spacing.200" height="100%" justifyContent="space-between">
        <Col gridGap="dimensions.spacing.200">
          <Link
            href={detailPath}
            onClick={(e: React.MouseEvent) => {
              e.preventDefault();
              history.push(detailPath);
            }}
            touchpoint="usecase-related-click"
            customData={{ relatedTitle: useCase.title }}
          >
            {useCase.title}
          </Link>
          {useCase.shortDescription && (
            <Text fontSize="T100" color="color.text.secondary">
              {displayText}
              {needsTruncation && (
                <Link
                  onClick={(e: React.MouseEvent) => {
                    e.preventDefault();
                    setExpanded(!expanded);
                  }}
                  href="#"
                  touchpoint="usecase-show-more"
                  customData={{ relatedTitle: useCase.title }}
                  aria-expanded={expanded}
                >
                  {expanded ? getString("useCases.detail.showLess") : getString("useCases.detail.showMore")}
                </Link>
              )}
            </Text>
          )}
        </Col>
        <Row gridGap="dimensions.spacing.200" alignItems="center">
          <Chip backgroundColor={ChipBackgroundColor.Default}>{useCase.tool}</Chip>
          <Text fontSize="T100" color="color.text.secondary">
            {getString("useCases.detail.usedCount", { count: String(useCase.used) })}
          </Text>
        </Row>
      </Col>
    </Card>
  );
};
